<template>
  <div class="mt-5">
    <b-container fluid>
      <div class="card mb-3">
        <div class="card-body py-2 px-3">
          <div class="row align-items-end">
            <div class="col-md-3">
              <div class="form-group m-0 p-0">
                <label class="small mb-0">Programme Type</label>
                <select
                  class="form-control form-control-sm"
                  v-model="filterProgrammeType"
                  @change="loadServiceTypes"
                >
                  <option value="">All</option>
                  <option
                    v-for="(d, index) in programmeTypes"
                    :key="index"
                    :value="d"
                  >
                    {{ d }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group m-0 p-0">
                <label class="small mb-0">Fee Type</label>
                <select
                  class="form-control form-control-sm"
                  v-model="filterType"
                  @change="loadServiceTypes"
                >
                  <option value="">All</option>
                  <option value="APPLICATION">Application</option>
                  <option value="ACCEPTANCE">Acceptance</option>
                  <option value="CAUTION">Caution</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <b-form-group label="Search" label-size="sm" class="mb-0">
                <b-form-input
                  v-model="filter"
                  type="search"
                  size="sm"
                  placeholder="Search..."
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4 text-right align-self-end">
              <button class="btn btn-success btn-sm" @click="openCreateModal">
                <i class="fas fa-plus"></i> Add Service Type
              </button>
            </div>
          </div>
        </div>
      </div>

      <b-table
        :busy="isBusy"
        :items="items"
        :fields="fields"
        :filter="filter"
        :current-page="currentPage"
        :per-page="perPage"
        stacked="md"
        show-empty
        small
        hover
        @filtered="onFiltered"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template #cell(actions)="row">
          <b-button size="sm" variant="info" class="mr-1" @click="openEditModal(row.item)">
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button size="sm" variant="danger" @click="confirmDelete(row.item)">
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
        <b-col md="6" class="my-1 text-right">
          <small class="text-muted">{{ totalRows }} record(s)</small>
        </b-col>
      </b-row>

      <!-- Create/Edit Modal -->
      <b-modal
        v-model="showModal"
        :title="editMode ? 'Edit Service Type' : 'Add Service Type'"
        size="lg"
        hide-footer
        centered
      >
        <form @submit.prevent="save">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Service Type ID <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="form.serviceType_id"
                  placeholder="Remita service type ID"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Programme Type <span class="text-danger">*</span></label>
                <select class="form-control form-control-sm" v-model="form.programme_type" required>
                  <option value="">Select</option>
                  <option
                    v-for="(d, index) in programmeTypes"
                    :key="index"
                    :value="d"
                  >
                    {{ d }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Fee Type <span class="text-danger">*</span></label>
                <select class="form-control form-control-sm" v-model="form.type" required>
                  <option value="">Select</option>
                  <option value="APPLICATION">Application</option>
                  <option value="ACCEPTANCE">Acceptance</option>
                  <option value="CAUTION">Caution</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Description</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="form.description"
                />
              </div>
            </div>
          </div>
          <div class="text-right mt-3">
            <button type="button" class="btn btn-secondary mr-2" @click="showModal = false">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <b-spinner small v-if="saving"></b-spinner>
              {{ editMode ? "Update" : "Create" }}
            </button>
          </div>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBusy: false,
      saving: false,
      items: [],
      filter: "",
      filterProgrammeType: "",
      filterType: "",
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      showModal: false,
      editMode: false,
      editId: null,
      form: this.emptyForm(),
      programmeTypes: [
        "PGD", "MA", "MBA", "MPHIL", "MPHIL-PHD", "MSC", "MMP", "LLM", "PHD", "CERTIFICATE"
      ],
      fields: [
        { key: "id", label: "ID", sortable: true },
        { key: "serviceType_id", label: "Service Type ID", sortable: true },
        { key: "type", label: "Fee Type", sortable: true },
        { key: "programme_type", label: "Programme Type", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  created() {
    this.loadServiceTypes();
  },
  methods: {
    emptyForm() {
      return {
        serviceType_id: "",
        type: "",
        programme_type: "",
        description: "",
      };
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    loadServiceTypes() {
      this.isBusy = true;
      let params = {};
      if (this.filterProgrammeType) params.programme_type = this.filterProgrammeType;
      if (this.filterType) params.type = this.filterType;

      axios
        .get("admin/service-types", { params })
        .then((response) => {
          let data = response.data.data || [];
          if (this.filterProgrammeType) {
            data = data.filter((d) => d.programme_type === this.filterProgrammeType);
          }
          if (this.filterType) {
            data = data.filter((d) => d.type === this.filterType);
          }
          this.items = data;
          this.totalRows = this.items.length;
        })
        .catch(() => {
          Toast.fire({ icon: "error", title: "Failed to load service types" });
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    openCreateModal() {
      this.editMode = false;
      this.editId = null;
      this.form = this.emptyForm();
      this.showModal = true;
    },
    openEditModal(item) {
      this.editMode = true;
      this.editId = item.id;
      this.form = {
        serviceType_id: item.serviceType_id || "",
        type: item.type || "",
        programme_type: item.programme_type || "",
        description: item.description || "",
      };
      this.showModal = true;
    },
    save() {
      this.saving = true;
      let request;
      if (this.editMode) {
        request = axios.put(`admin/service-types/${this.editId}`, this.form);
      } else {
        request = axios.post("admin/service-types", this.form);
      }

      request
        .then(() => {
          Toast.fire({
            icon: "success",
            title: this.editMode ? "Service type updated" : "Service type created",
          });
          this.showModal = false;
          this.loadServiceTypes();
        })
        .catch((err) => {
          const msg =
            err.response && err.response.data && err.response.data.error
              ? typeof err.response.data.error === "string"
                ? err.response.data.error
                : "Validation error"
              : "Operation failed";
          Toast.fire({ icon: "error", title: msg });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    confirmDelete(item) {
      Swal.fire({
        title: "Delete this service type?",
        text: `${item.serviceType_id} - ${item.type} (${item.programme_type})`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteServiceType(item.id);
        }
      });
    },
    deleteServiceType(id) {
      axios
        .delete(`admin/service-types/${id}`)
        .then(() => {
          Toast.fire({ icon: "success", title: "Service type deleted" });
          this.loadServiceTypes();
        })
        .catch((err) => {
          const msg =
            err.response && err.response.data && err.response.data.error
              ? err.response.data.error
              : "Delete failed";
          Toast.fire({ icon: "error", title: msg });
        });
    },
  },
};
</script>
